import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {ACTION_TYPES} from "../../../core/consts";
import {RouterController} from "../../../core/components/router/router-controller";

export class WebsiteModuleFloatingButtonClickHandler extends ActionHandler {
  type = ACTION_TYPES.floatingButtonClick;

  static injectables = [RouterController];

  constructor(routerController: RouterController) {
    super();
    this.routerController = routerController;
  }

  action(params) {
    this.navigationManager.gotoUrl(params.url, false, true);
    this.controller.action(ACTION_TYPES.floatingButtonClickEvent);
  }
}
